<template>
    <section class="innerpages animate__animated animate__slideInRight">
      <div class="container ">
        <div class="row">
          <div class="col-md-12 listPage">
            <div class="d-flex align-items-center">
              <h1 class="text-truncate mr-2" :title="project_name">{{project_name}}</h1>
            <button @click="showModal = true" class="btn btn-sm p-0" aria-label="Edit title">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="currentColor" fill-rule="evenodd"
                  d="M3.25 22a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75"
                  clip-rule="evenodd" />
                <path fill="currentColor"
                  d="m11.52 14.929l5.917-5.917a8.2 8.2 0 0 1-2.661-1.787a8.2 8.2 0 0 1-1.788-2.662L7.07 10.48c-.462.462-.693.692-.891.947a5.2 5.2 0 0 0-.599.969c-.139.291-.242.601-.449 1.22l-1.088 3.267a.848.848 0 0 0 1.073 1.073l3.266-1.088c.62-.207.93-.31 1.221-.45q.518-.246.969-.598c.255-.199.485-.43.947-.891m7.56-7.559a3.146 3.146 0 0 0-4.45-4.449l-.71.71l.031.09c.26.749.751 1.732 1.674 2.655A7 7 0 0 0 18.37 8.08z" />
              </svg>
            </button>
            </div>

            <div class="mt-2 counts-row">
              <!-- Row 1: Total Spent -->
              <div class="count-block mb-1">
                <span class="count-label gray-text">Total Spend:</span>
                <span class="count-value gray-text" style="font-weight: bold;">{{ total_spend }}</span>
              </div>

              <!-- Row 2: Leads -->
              <div class="count-block">
                <span class="count-label gray-text">Leads:</span>
                <span class="count-value gray-text fw-bold" style="font-weight: bold;">{{ count }}</span>
              </div>
            </div>
            <div class="card ">
              <b-table
                :items="masterData"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                sort-icon-right
                responsive="sm"
                show-empty
                tbody-tr-class="dataDivider"
                class="fixed-width-table1"
                >
                <template v-slot:empty="scope">
                <h5 class="noData">No Data</h5>
              </template>
              <template v-slot:cell(total_leads)="data">
                <span @click.stop="goToLeads('total_leads', data.item)" class="clickable" :class="{ 'text-orange': data.item.total_leads > 0 }">
                  {{ data.item.total_leads }}
                </span>
              </template>
              <template v-slot:cell(total_dq_ql_leads)="data">
                <span @click.stop="goToDQLeads('total_dq_ql_leads', data.item)" class="clickable" :class="{ 'text-orange': data.item.total_dq_ql_leads > 0 }">
                  {{ data.item.total_dq_ql_leads }}
                </span>
              </template>
              <template v-slot:cell(cost)="data">
                <span
                  @click.stop="shouldAllowClick(data.item) && goToMasterCPL(data.item)"
                  class="clickable"
                  :class="getCostClass(data.item)"
                >
                  {{ data.item.cost }}
                </span>
              </template>
              </b-table>
            </div>
            <b-modal v-model="showModal" title="Edit Project" hide-footer centered>
            <div>
              <b-form-group label="Project Name">
                <multiselect 
                  class="mt-2" v-model="project_id" @search-change="populateSuggestions"
                  :searchable="true" :placeholder="`Type to search`" label="name"
                  track-by="id" :options="projects ? projects : []" :multiple="false" :taggable="true">
                </multiselect>
              </b-form-group>              
              <div class="d-flex justify-content-end mt-3">
                <b-button
                  :disabled="!project_id"
                  @click="loadData"
                  class="btn-sm text-primary border-primary bg-white"
                >
                  Update
                </b-button>
              </div>
            </div>
          </b-modal>
          </div>
        </div>
      </div>
    </section>
  </template>
  <script>
  import Multiselect from 'vue-multiselect';
    export default {
      components: {
        Multiselect,
      },
     data(){
      return {
        sortBy: 'count',
        sortDesc: false,
        showModal: false,
        selectedItem: null,
        selectedOption: '',
        masterData: [],
        project_id: '',
        projects: [],
        project_name: '',
        total_spend: '',
        count: ''

      }
    },
    watch: {
      $route(to, from) {
        this.loadData();
      },
    },
    mounted() {
      this.loadData()
      this.$store.dispatch('setActiveTitle', "Marketing Activation Report");
    },
    methods: {
      handleCountClick(item) {
        this.selectedItem = item;
        this.showModal = true;
      },
      shouldAllowClick(item) {
        const hasManagerId = this.$route.query.manager_ids;
        return (item.cost !== 0.0 && !hasManagerId);
      },
      getCostClass(item) {
        const hasManagerId = !!this.$route.query.manager_ids;
        if (hasManagerId && item.cost === 0.0) {
          return '';
        } else if (item.cost === 0.0) {
          return 'text-muted';
        } else if (item.cost > 0 && !hasManagerId) {
          return 'text-orange';
        }
        return '';
      },
      loadData() {
        const currentQuery = { ...this.$route.query };
        if (this.project_id && this.project_id.id) {
          currentQuery.project_id = this.project_id.id;
        }
        const queryParams = {
          start_date: currentQuery.start_date,
          end_date: currentQuery.end_date,
          manager_ids: currentQuery.manager_ids,
          project_ids: currentQuery.project_ids,
          source_ids: currentQuery.source_ids,
          is_star_project: currentQuery.is_star_project,
          project_id: currentQuery.project_id
        };

        Object.keys(queryParams).forEach(key => {
          if (!queryParams[key]) delete queryParams[key];
        });

        if (JSON.stringify(this.$route.query) !== JSON.stringify(queryParams)) {
          this.$router.replace({ path: this.$route.path, query: queryParams });
        }

        const searchParams = new URLSearchParams(queryParams).toString();
        const url = `/marketing_activation_report?${searchParams}`;

        this.$axios.get(url)
          .then(res => {
            if (res.data.length > 0) {
              this.masterData = res.data[0].data;
              this.project_name = res.data[0].name
              this.total_spend = res.data[0].total_spend
              this.count = res.data[0].count
            } else {
              this.masterData = []
              this.project_name = this.project_id.name
              this.total_spend = 0
              this.count = 0
            }
            this.showModal = false
          })
          .catch((err) => {
            if (err.response?.status === 500) {
              swal({ title: "Server Error!", icon: "error" });
            } else {
              swal({
                title: "Error",
                text: err.response?.data?.message || "Something went wrong",
                icon: "error",
              });
            }
          });
      },
      populateSuggestions(event){
        if(event.length === 3){
          let url = `/projects?input_str=${event.trim()}`
          this.$axios.get(url)
            .then(res => {
              if(res.data.projects.length > 0){
                this.projects = res.data.projects
              }
            })
            .catch(err => {
            })
        }
    },
      goToLeads(field, item) {
        this.$router.push({
          path: `/leads/for/marketing_activation/${this.$route.query.project_id}`,
          query: {
            ...this.$route.query,
            lead_type: "total_leads",
            enquiry_source_id: item.enquiry_source_id
          }
        });
      },
      goToDQLeads(field, item) {
        this.$router.push({
          path: `/leads/for/marketing_activation/${this.$route.query.project_id}`,
          query: {
            ...this.$route.query,
            lead_type: "total_leads",
            enquiry_source_id: item.enquiry_source_id,
            is_qualified: true
          }
        });
      },
      goToMasterCPL(item) {
        this.$router.push({
          path: `/mastercpl/for/marketing_activation/${this.$route.query.project_id}`,
          query: {
            ...this.$route.query,
            enquiry_source_ids: item.enquiry_source_id,
            project_ids: this.$route.query.project_id,
            cpls_wrt_leads: true
          }
        });
      },
    },
    computed: {
      activeItem(){
        return this.$store.getters.activeItem;
      },
      activeTitle(){
        return this.$store.getters.activeTitle;
      },
      fields() {
        return [
          {
            key: 'name',
            label: "Source",
            thStyle: { width: '30%' }
          },
          {
            key: 'total_leads',
            label: "Leads",
            thStyle: { width: '20%' }
          },
          {
            key: 'total_dq_ql_leads',
            label: "(QL + DQL)",
            thStyle: { width: '25%' }
          },
          {
            key: 'cost',
            label: "Cost",
            thStyle: { width: '25%' }
          },
        ];
    },
      defaultDates(){
        return this.$store.getters.defaultDates;
      },
      fromDate(){
        return this.defaultDates.from;
      },
      toDate(){
        return this.defaultDates.upto;
      }
    }
  }
  </script>
  <style lang="css" scoped>

.row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -25px;
    margin-left: -25px;
}
.count-block {
  font-size: 14px;
}

.gray-text {
	color: #000000;
	opacity: .5;
}
.text-orange {
  color: orange;
}
.text-muted {
  color: #ccc;
  cursor: default;
}

.clickable {
  cursor: pointer;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>